import clsx from 'clsx';
import type { ReactNode } from 'react';

interface KpiProps {
  label: ReactNode;
  value?: ReactNode;
  sub?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
}

// Prop-compatible redesign of widgets/stats/KpiCard.tsx (same label/value/sub/footer
// shape) — a mechanical swap for every consumer once Phase 4 adopts it.
export function Kpi({ label, value, sub, footer, children, className }: KpiProps) {
  return (
    <div className={clsx('rounded-xl bg-base-100 px-4 py-3.5 shadow-card', className)}>
      <div className="flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wider text-base-content/60">
        {label}
      </div>
      {value !== undefined && (
        <div className="mt-1.5 font-mono text-[1.75rem] font-semibold leading-none text-base-content">{value}</div>
      )}
      {sub && <div className="mt-1 text-sm text-base-content/70">{sub}</div>}
      {children}
      {footer && <div className="mt-2 text-xs text-base-content/50">{footer}</div>}
    </div>
  );
}
